<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="711px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.downTip1') }}<br />
      2.{{ $t('ExcelConfig.downTip2') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.downTip3') }}<br />
      4.{{ $t('ExcelConfig.downTip4') }}<br />
      5.{{ $t('ExcelConfig.downTip5') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importStart"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button :disabled="sureImport" type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { importApi, commonApi, settingApi, baseDataApi, goodsApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
import papa from 'papaparse';

const DIMENSION_SIDE_LIMIT = 120;
const DIMENSION_SUM_LIMIT = 200;

export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      templateDownloadCode: null,
      skuList: null,
      barcodeList: null,
      sureImport: false, 
      oversizeDimensionNeedConfirm: false,
      // 父级传进来的参数，下载模版使用
      lovCode:null,
    };
  },
  methods: {
    // 根据租户获取下载模板code
    async getTenantTemplateCode() {
      const meaning = this.$store.getters.tenantNum;
      const res1 = await baseDataApi.getLovHeadersByLovCode({lovCode: this.lovCode});
      const lovId = res1.lovId;
      const queryPrams = {
        lovCode: this.lovCode,
        lovId,
        meaning
      };
      const res2 = await baseDataApi.getLovValuesByLovId(queryPrams);
      if (!res2.content?.length) return;
      // 当前租户模板code
      this.templateDownloadCode = res2.content[0].value;
    },
    show() {
      this.file = null;
      this.oversizeDimensionNeedConfirm = false;
      this.dialogVisible = true;
      this.getTenantTemplateCode();
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: this.templateDownloadCode,
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi.downloadFileByUrl({
          bucketName: DEFAULT_BUCKET_NAME,
          url: res.content[0].templateUrl,
        }).then(resp => {
          downloadBlob(resp, this.lovCode == 'SGOO.SKU_IMPORT'? 'SKU import template.xlsx' :'Sales Kit import template.xlsx' );
        });
      });
    },
    isValidToTwo(str) {
      return !isNaN(str) && str > 0;
    },
    needOversizeDimensionConfirm(item) {
      const dimensions = [item['product-length'], item['product-width'], item['product-height']].map(value => Number(value) || 0);
      return dimensions.some(value => value >= DIMENSION_SIDE_LIMIT) ||
        dimensions.reduce((total, value) => total + value, 0) >= DIMENSION_SUM_LIMIT;
    },
    beforeVerify(dataList) {
      return new Promise((resolve) => {
        let bstop = true;
        const skuMap = {};
        const barcodeMap = {};
        this.oversizeDimensionNeedConfirm = false;
        this.barcodeList = new Set();
        this.skuList = new Set();
        const reg = /^[`~!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
        if(this.lovCode ==  'SGOO.SKU_IMPORT'){
          dataList.forEach(item => {
            if(/\s/.test(item['sku'])){
              item.errorTip = `SKU ${this.$t('goodsPage.ps12')}`;
              bstop = false;
              return;
            }
            if(!reg.test(item['sku'])){
              item.errorTip = `SKU ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }

            if (item['barcode'] && String(item['barcode']).trim() && !this.barcodeList.has(item['barcode'])) {
              this.barcodeList.add(String(item['barcode']).trim());
              this.skuList.add(String(item['sku']).trim());
            }

            item.errorTip = '';
            if (skuMap[item['sku']]) { // 如果sku已经存在
                item.errorTip = `SKU duplication.`;
                bstop = false;
                return;
            }
            // if (!['ITEM', 'PACKAGE BOX'].includes(String(item['type']).toUpperCase())) {
            //   item.errorTip = `type error`;
            //   bstop = false;
            //   return;
            // }
            if (item['barcode'] && String(item['barcode']).trim() && barcodeMap[item['barcode']]) { // 如果sku已经存在
                item.errorTip = `Barcode duplication.`;
                bstop = false;
                return;
            }
            // 无论sku是否已存在，都将其添加到skuMap中
            skuMap[item['sku']] = true;
            barcodeMap[item['barcode']] = true;
            if (!item['product-name']) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " product-name "`;
              bstop = false;
              return;
            }
            if (!item['product-length']) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " product-length "`;
              bstop = false;
              return;
            }
            if (!item['product-width']) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " product-width "`;
              bstop = false;
              return;
            }
            if (!item['product-height']) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " product-height "`;
              bstop = false;
              return;
            }
            if (!item['product-weight']) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " product-weight "`;
              bstop = false;
              return;
            }
            if (!item['sku'] && item['sku'] != 0) {
              item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " sku "`;
              bstop = false;
              return;
            }
            if (item['barcode'] && (/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(String(item['barcode'])) || String(item['barcode']).length>14)) {
              item.errorTip = `${this.$t('ExcelConfig.tip3')}`;
              bstop = false;
              return;
            }
            // if (!item['cost-price']) {
            //   item.errorTip = `rule 1 error：${this.$t('goodsPage.ps1')} " cost-price "`;
            //   bstop = false;
            //   return;
            // }
            if (item['cost-price'] && !(!isNaN(item['cost-price']) && item['cost-price'] >= 0) ) {
              item.errorTip = `rule 4 error：${this.$t('goodsPage.ps4')}`;
              bstop = false;
              return;
            }
            if (item['carton-itemPerCarton'] && !/^[1-9]\d*$/.test(item['carton-itemPerCarton'])) {
              item.errorTip = `rule 5 error：${this.$t('goodsPage.ps5')}`;
              bstop = false;
              return;
            }
            if (!this.isValidToTwo(item['product-length'])) {
              item.errorTip = `rule 6 error：${this.$t('goodsPage.ps6_1')}`;
              bstop = false;
              return;
            }
            if (!this.isValidToTwo(item['product-width'])) {
              item.errorTip = `rule 6 error：${this.$t('goodsPage.ps6_2')}`;
              bstop = false;
              return;
            }
            if (!this.isValidToTwo(item['product-height'])) {
              item.errorTip = `rule 6 error：${this.$t('goodsPage.ps6_3')}`;
              bstop = false;
              return;
            }
            if (!this.isValidToTwo(item['product-weight'])) {
              item.errorTip = `rule 6 error：${this.$t('goodsPage.ps6_4')}`;
              bstop = false;
              return;
            }
            if (!item['carton-itemPerCarton'] || item['carton-itemPerCarton'] == 1) {
                if (Number(item['carton-length']) && Number(item['carton-length']) < Number(item['product-length'])) {
                  item.errorTip = `rule 8 error：${this.$t('goodsPage.ps8')}`;
                  bstop = false;
                  return;
                } else {
                  item['carton-length'] = item['product-length'];
                }
                if (Number(item['carton-width']) && Number(item['carton-width']) < Number(item['product-width'])) {
                  item.errorTip = `rule 9 error：${this.$t('goodsPage.ps9')}`;
                  bstop = false;
                  return;
                } else {
                  item['carton-width'] = item['product-width'];
                }
                if (Number(item['carton-height']) && Number(item['carton-height']) < Number(item['product-height'])) {
                  item.errorTip = `rule 10 error：${this.$t('goodsPage.ps10')}`;
                  bstop = false;
                  return;
                } else {
                  item['carton-height'] = item['product-height'];
                }
                if (Number(item['carton-weight']) && Number(item['carton-weight']) < Number(item['product-weight'])) {
                  item.errorTip = `rule 11 error：${this.$t('goodsPage.ps11')}`;
                  bstop = false;
                  return;
                } else {
                  item['carton-weight'] = item['product-weight'];
                }
            } else if (item['carton-itemPerCarton'] > 1) {
              if (!this.isValidToTwo(item['carton-length']) || !item['carton-length']) {
                item.errorTip = `rule 7 error：${this.$t('goodsPage.ps7_1')}`;
                bstop = false;
                return;
              }
              if (!this.isValidToTwo(item['carton-width']) || !item['carton-width']) {
                item.errorTip = `rule 7 error：${this.$t('goodsPage.ps7_2')}`;
                bstop = false;
                return;
              }
              if (!this.isValidToTwo(item['carton-height']) || !item['carton-height']) {
                item.errorTip = `rule 7 error：${this.$t('goodsPage.ps7_3')}`;
                bstop = false;
                return;
              }
              if (!this.isValidToTwo(item['carton-weight']) || !item['carton-weight']) {
                item.errorTip = `rule 7 error：${this.$t('goodsPage.ps7_4')}`;
                bstop = false;
                return;
              }
              if (Number(item['carton-length']) < Number(item['product-length'])) {
                item.errorTip = `rule 8 error：${this.$t('goodsPage.ps8')}`;
                bstop = false;
                return;
              }
              if (Number(item['carton-width']) < Number(item['product-width'])) {
                item.errorTip = `rule 9 error：${this.$t('goodsPage.ps9')}`;
                bstop = false;
                return;
              }
              if (Number(item['carton-height']) < Number(item['product-height'])) {
                item.errorTip = `rule 10 error：${this.$t('goodsPage.ps10')}`;
                bstop = false;
                return;
              }
              if (Number((item['product-weight'] * item['carton-itemPerCarton']).toFixed(4)) > Number(item['carton-weight'])) {
                item.errorTip = `rule 11 error：${this.$t('goodsPage.ps11')}`;
                bstop = false;
                return;
              }
            }
            if (this.needOversizeDimensionConfirm(item)) {
              this.oversizeDimensionNeedConfirm = true;
            }
            if (item['need-expired'] == 0 || (item['need-expired'] && !['YES', 'NO'].includes(String(item['need-expired']).toUpperCase()))) {
              item.errorTip = `rule 3 error：${this.$t('goodsPage.rule3')}`;
              bstop = false;
              return;
            }
            if (item['need-serial-no'] == 0 || (item['need-serial-no'] && !['YES', 'NO'].includes(String(item['need-serial-no']).toUpperCase()))) {
              item.errorTip = `rule 3 error：${this.$t('goodsPage.rule13')}`;
              bstop = false;
              return;
            }
          });
        }else if(this.lovCode ==  'SGOO.PACKAGE_SKU_IMPORT_CSG'){
          dataList.forEach(item => {
            item.errorTip = '';
            if(/\s/.test(item['sku'])){
              item.errorTip = `${this.$t('goodsPage.ps12')}`;
              bstop = false;
              return;
            }
            if(!reg.test(item['sku'])){
              item.errorTip = `SKU ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }
            if (skuMap[`${item['sku']}_${item['sales kit sku']}`]) {
                item.errorTip = `sales kit sku_SKU duplication.`;
                bstop = false;
                return;
            }
            if (skuMap[item['sales kit name']]) {
                item.errorTip = `sales kit name duplication.`;
                bstop = false;
                return;
            }
            if(/\s/.test(item['sales kit sku'])){
              item.errorTip = `sales kit sku ${this.$t('ExcelConfig.tip4')}`;
              bstop = false;
              return;
            }
            if(!reg.test(item['sales kit sku'])){
              item.errorTip = `sales kit sku ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }
            skuMap[`${item['sku']}_${item['sales kit sku']}`] = true;
            // skuMap[item['sales kit sku']] = true;
            if (!item['sales kit name']) {
              item.errorTip = `${this.$t('goodsPage.ps1')} " sales kit name "`;
              bstop = false;
              return;
            }
            if (!item['sales kit sku']) {
              item.errorTip = `${this.$t('goodsPage.ps1')} " sales kit sku "`;
              bstop = false;
              return;
            }
            if (!item['sku'] && item['sku'] != 0) {
              item.errorTip = `${this.$t('goodsPage.ps1')} " sku "`;
              bstop = false;
              return;
            }
            if (!item['sales kit sku'] && item['sales kit sku'] != 0) {
              item.errorTip = `${this.$t('goodsPage.ps1')} " sales kit sku "`;
              bstop = false;
              return;
            }
            if(!item['qty']){
              item.errorTip = `qty ${this.$t('emptyWarningText1')}`;
              bstop = false;
              return;
            }
            if (/^(?:[0-9]\d*)$/.test(item['qty']) == false) {
              item.errorTip =`qty ${this.$t('formatErrorText')}`;
              bstop = false;
              return;
            }
          })
        }

        resolve(bstop ? [] : dataList);
      });
    },
    // 判断文件是否有公式
    importStart(file) {
      this.file = null;
      this.oversizeDimensionNeedConfirm = false;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const XLSX = require('xlsx');
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        let canDo = true
        // 遍历所有单元格
        Object.keys(worksheet).forEach(cellAddress => {
          if (cellAddress.startsWith('!')) return; // 跳过非单元格属性（如 !ref）
          const cell = worksheet[cellAddress];
          // 判断是否是公式
          if (cell.f){
            canDo = false
            this.$message.error(` ${cellAddress} ${this.$t('goodsPage.ps13')}`); return
          }
        });

        if(canDo){
          console.log(file,'file');
          this.sureImport = false
          this.importFile(file)
        }else{
          this.sureImport = true
        }
      };
      reader.readAsArrayBuffer(file);
    },
    importFile(file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, { type: 'binary' });
        const excelList = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        if(excelList.length == 0){return this.$message.warning(this.$t('goodsPage.ps1'));}
        this.beforeVerify(excelList).then(dataList => {
          if ([...this.barcodeList].length > 0) {
            goodsApi.checkBarCode({barCode: [...this.barcodeList], skuCode: [...this.skuList]}).then(res => {
              if (!res.failed) {
                this.afterUpload(dataList, file);
              }
            });
          } else {
            this.afterUpload(dataList, file);
          }
        });
      };
    },
    afterUpload(dataList, file) {
      if (dataList.length > 0) {
        this.$confirm(`${this.$t('ExcelConfig.excelEroorTip')}`, this.$t('toast.hintText'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('downloadText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
          customClass: 'customFileSize-width'
        }).then(() => {
          const csvData = [];

          dataList.forEach(item => {
            if(this.lovCode ==  'SGOO.SKU_IMPORT'){
              csvData.push({
                'product-name': item['product-name'],
                'sku': item['sku'],
                'barcode': item['barcode'],
                'description': item['description'],
                'carton-itemPerCarton': item['carton-itemPerCarton'],
                'product-length': item['product-length'],
                'product-width': item['product-width'],
                'product-height': item['product-height'],
                'product-weight': item['product-weight'],
                // 'type': item['type'],
                'carton-length': item['carton-length'],
                'carton-width': item['carton-width'],
                'carton-height': item['carton-height'],
                'carton-weight': item['carton-weight'],
                'cost-price': item['cost-price'],
                'need-expired': item['need-expired'],
                'need-serial-no': item['need-serial-no'],
                'is-wine': item['is-wine'],
                'error': item.errorTip
              });
            }else{
              csvData.push({
                'sales kit name': item['sales kit name'],
                'sales kit sku': item['sales kit sku'],
                'sku': item['sku'],
                'qty': item['qty'],
                'error': item.errorTip
              });
            }
          });

          const csv = papa.unparse(csvData);
          const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const csvURL = window.URL.createObjectURL(data);
          const download = document.createElement('a');
          document.body.appendChild(download);
          download.href = csvURL;
          download.setAttribute('download', this.lovCode ==  'SGOO.SKU_IMPORT'? 'SKU import template' :'Sales Kit import template');
          download.click();
          document.body.removeChild(download);
        });
      } else {
        if (this.oversizeDimensionNeedConfirm) {
          this.$confirm(this.$t('goodsSku.detail.oversizeDimensionConfirm'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
            customClass: 'oversize-dimension-confirm'
          }).then(() => {
            this.file = file;
          }).catch(() => {});
        } else {
          this.file = file;
        }
      }
    },
    confirm() {
      if (this.file) {
        commonApi.autoImport({
          prefix: 'sgoo',
          excel: this.file,
          templateCode: this.templateDownloadCode,
        }).then(() => {
          this.$message.success(this.$t('toast.operationSuccessText'))
          this.hide();
          setTimeout(() => {
            this.$emit('submit',this.lovCode);
          }, 1000);
        });
      } else {
        this.$message({
            message: this.$t('ExcelConfig.upload'),
            type: 'warning',
            duration: 5000,
        });
      }
    },
  },
};
</script>
<style scope>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
<style>
.customFileSize-width {
  width: 470px; /* 或者任何你想要的宽度 */
}
</style>
